<template>
  <div>
    <select
      class="form-control"
      @change="onChanged($event)"
      :disabled="disabled"
    >
      <option value="-1" :selected="selectedVal == -1"
        >---{{ $t("messages.general.notSpecified") }}---</option
      >
      <option
        v-for="(item, index) in items"
        :key="index"
        :value="item.TYPEID"
        :selected="selectedVal == item.TYPEID"
      >
        {{ item.TYPENAME }}
      </option>
    </select>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
// import MasterDataProvider from "@/services/masterData_provider";

// const masterDataProvider = new MasterDataProvider();

export default {
  name: "TYPE",
  props: {
    onChanged: Function,
    selectedVal: Number,
    disabled: { type: Boolean, default: true }
  },
  data: () => {
    return {
      items: []
    };
  },
  computed: {
    ...mapGetters("application", {
      appInfo: "getUserInfo",
      token: "getToken"
    }),
    currentLang: function() {
      return this.appInfo.currentLocale;
    }
  },
  async mounted() {
    this.loadData();
  },
  methods: {
    ...mapActions("application", ["togglePreLoader"]),
    loadData() {
      this.togglePreLoader(true);
      this.items = [
        { TYPEID: 0, TYPENAME: "O-เปิด" },
        { TYPEID: 1, TYPENAME: "C-ปิด" },
        { TYPEID: 2, TYPENAME: "COP-ปิดยื่นได้" }
      ];
      this.togglePreLoader(false);
    }
  },
  watch: {
    currentLang() {
      this.loadData();
    }
  }
};
</script>
